import { render, staticRenderFns } from "./DieCheckModal.vue?vue&type=template&id=794f4424&scoped=true"
import script from "./DieCheckModal.vue?vue&type=script&lang=js"
export * from "./DieCheckModal.vue?vue&type=script&lang=js"
import style0 from "./DieCheckModal.vue?vue&type=style&index=0&id=794f4424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f4424",
  null
  
)

export default component.exports